import { render, staticRenderFns } from "./compClubConfig.vue?vue&type=template&id=0ff232f4"
import script from "./compClubConfig.vue?vue&type=script&lang=js"
export * from "./compClubConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports